/**
 * Sdílené formátování peněžních částek pro celou appku.
 *
 * Formát je cs-CZ: oddělovač tisíců, pevný počet desetinných míst (default 1). Nezobrazuje kód měny
 * (ten se renderuje zvlášť, viz komponenta `Money`) ani neřeší zalomení (to je věc renderu).
 */

const formatterCache = new Map<number, Intl.NumberFormat>();

function getFormatter(decimals: number): Intl.NumberFormat {
  let formatter = formatterCache.get(decimals);
  if (!formatter) {
    formatter = new Intl.NumberFormat('cs-CZ', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
    formatterCache.set(decimals, formatter);
  }
  return formatter;
}

export interface FormatMoneyOptions {
  /** Počet desetinných míst (default 1). */
  decimals?: number;
}

/** Naformátuje částku v cs-CZ (oddělovač tisíců, pevný počet desetinných míst, default 1). */
export function formatMoney(value: number, options?: FormatMoneyOptions): string {
  const decimals = options?.decimals ?? 1;
  return getFormatter(decimals).format(Number.isFinite(value) ? value : 0);
}
